import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import { Link } from '../../../../atoms/link';
import { Typography } from '../../../../atoms/typography';
import { useBannerContext } from '../../banner.context';

import * as styles from './banner-link.styles';

type Props = {
  children: ReactNode;
  className?: string;
  href?: string;
  target?: '_blank';
  to?: string;
};

export const BannerLink = ({ children, className, href, target, to }: Props) => {
  const theme = useTheme();
  const { size } = useBannerContext();

  return (
    <Typography
      className={className}
      css={[styles.text, styles.textSize[size](theme), theme.presentation.banner.link[size]]}
      variant={size === 'medium' ? 'bodyMediumMobile' : 'b3'}>
      <Link href={href} target={target} to={to}>
        {children}
      </Link>
    </Typography>
  );
};
